import { Button, ButtonGroup, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { CardLayout, SaveButtonsContainer } from '../../../components/common';
import ContentConstants from '../../../contentConstants';
import { IHasValidationModel, ISurveyAdminSummary, UserType } from '../../../models';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { MinN } from '../../reporting/MinN';

export interface IAnonymityThresholdProps extends IHasValidationModel {
	clientMinN: number | undefined;
	isClosed?: boolean;
	isLoading: boolean;
	isSavingSurveyMinN: boolean;
	surveyAdminSummary?: ISurveyAdminSummary;
	surveyId: number;
	surveyMinN: number | undefined;
	userType: UserType;
	SaveSurveyMinN: (surveyId: number) => void;
	MinNChange: (minN: number) => void;
}

export class AnonymityThreshold extends React.Component<IAnonymityThresholdProps> {
	public render() {
		const { isClosed, isLoading, isSavingSurveyMinN, surveyAdminSummary, surveyId, userType, SaveSurveyMinN } = this.props;

		const readOnly = isClosed || surveyAdminSummary?.surveyStatus === SurveyStatusType.Cancelled || userType !== UserType.Internal;

		return (
			<>
				<CardLayout loading={isLoading} title={ContentConstants.SURVEY_ADMIN_ACTION_ANONYMITY_THRESHOLD}>
					<MinN {...this.props} readOnly={readOnly} />
					<Divider type='dashed' />
					<SaveButtonsContainer>
						<ButtonGroup type='column'>
							<Button
								id='SaveChangesButton'
								color='primary'
								size='lg'
								disabled={readOnly || isLoading || isSavingSurveyMinN}
								onClick={() => SaveSurveyMinN(surveyId)}
							>
								{ContentConstants.BUTTON_SAVE_CHANGES}
							</Button>
						</ButtonGroup>
					</SaveButtonsContainer>
				</CardLayout>
			</>
		);
	}
}
